import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

import HelpAndSupportHeader from '../CommonComponents/HelpAndSupportHeader';
import HelpAndSupportFooter from '../CommonComponents/HelpAndSupportFooter';
import ErrorMessage from '../CommonComponents/ErrorMessage';

import api from '../../api/api';

class ArticleDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headerMessage: {
                title: "",
                description: "",
                backIcon: false,
                moreOptionhidden: true,
                searchOptionHidden: true,
            },
            articlesName: '',
            articlesBody: '',
            displayErrorPopup : false,
        }
    }

    /**
     * this is for Go Back
     */
    goBack = () => {
        this.props.history.goBack();
    }
    /**
     * Error PopUp Close Click
     */
    errorCloseCLick = () => {
        this.setState({
            displayErrorPopup: false
        });
    }
    /**
     * as the component is loaded it will call display popup
     * and it calls the articles details api for displaying article
     */
    componentDidMount() {
        api.displayMainLoader();
        api.displayArticleDetails(this.props.match.params.id)
            .then(data => {
                this.setState({
                    articlesName: data.data.title,
                    articlesBody: data.data.description
                });
                api.displayHideLoader();
            })
            .catch(error => {
                this.setState({
                    displayErrorPopup : true
                });
                api.displayHideLoader();
                console.log(error);
            });
    }

    render() {
        return (
            <div>
            {
                (this.state.displayErrorPopup ? <ErrorMessage onCloseClick={this.errorCloseCLick.bind(this)} /> : '')
            }
                <HelpAndSupportHeader displayMessage={this.state.headerMessage} back={this.goBack.bind(this)} />
                <div className="body-container">
                    <div className="article-title">
                        {
                            this.state.articlesName
                        }
                    </div>
                    <div className="article-body" >
                        {
                            ReactHtmlParser(this.state.articlesBody)
                        }
                    </div>
                    <div className="">
                    </div>
                </div>
                <HelpAndSupportFooter />
            </div>
        )
    }
}


export default ArticleDetails;


// WEBPACK FOOTER //
// ./src/components/Articles/ArticleDetails.js